import React from "react";

const Schedule = () => {
  return (
    <div className="container mt-4">
      <h4>Schedule Timing</h4>

      <div className="card p-3">
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Job</th>
              <th>Timing</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {[1,2,3].map(i => (
              <tr key={i}>
                <td>Antony</td>
                <td>Accountant</td>
                <td>10AM - 12PM</td>
                <td>
                  <button className="btn btn-sm btn-dark">
                    Schedule
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Schedule;